import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/milestones-summary")({
  component: lazyRouteComponent(() => import("./-pages/admin.milestones-summary")),
  head: () => ({
    meta: [
      { title: "Milestones Summary — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});
